import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Proof } from '@feature/proof';
import { generateProofApi, generateProofOptions } from '@feature/proof/proofGenerator';
import { Id } from '@feature/utils';

const awardProofApi = generateProofApi('/proof-file/award');
const { getProofsOptions, getProofsByOwnerOptions, createOrUpdateProofOptions, deleteProofOptions } =
  generateProofOptions('award', awardProofApi);

export function getAwardProofsByOwnerOptions(awardId: Id, userId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsByOwnerOptions(awardId, userId);
}

export function getAwardProofsOptions(awardId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsOptions(awardId);
}

export function useUploadOrUpdateAwardProof(awardId: Id) {
  const queryClient = useQueryClient();
  return useMutation(createOrUpdateProofOptions(awardId, queryClient));
}

export function useDeleteAwardProof(awardId: Id) {
  const queryClient = useQueryClient();
  return useMutation(deleteProofOptions(awardId, queryClient));
}
